export default __webpack_public_path__ + "static/media/LETO@FIFOU-3396.9434f7ec.jpg";